import {needAuth} from "../../instance/Instance";
import {getParam} from "../../../components/Utils/Utils";
import {AxiosError} from "axios";
import {apiRequest} from "../../../components/Utils/SimmsUtils";

const getRentalAssets = async (search, pageable) => {
    try {
        return await needAuth.post(`/rental?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

// 대여중인 자산을 제외한 자산목록을 드로워에서 조회
const getRentalAssetsForDrawer = async (search, pageable) => {
    try {
        return await needAuth.post(`/rental/drawer?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getRentalAsset = async (id, success) => {
    return apiRequest(() => needAuth.get(`/rental/${id}`), success);
}

const saveRentalAssets = async (data, success) => {
    return apiRequest(() => needAuth.post(`/rental/save`, data), success);
}

const removeRentalAsset = async (data, success) => {
    return apiRequest(() => needAuth.put(`/rental/remove`, data), success);
}

const updateRentalAssetCode = async (data, success) => {
    return apiRequest(() => needAuth.put(`/rental/code`, data), success);
}

const changeRentalAssetActive = async (data, success) => {
    return apiRequest(() => needAuth.put(`/rental/active`, data), success);
}

const matchesAssetId = (item, assetId) => (
    item?.asset?.id === assetId
    || item?.assetId === assetId
);

const findRentalAssetIdByAssetId = async (assetId) => {
    const searchPayloads = [
        {asset: {id: assetId}},
        {assetId},
    ];

    for (const search of searchPayloads) {
        const pageable = {page: 0, size: 50, sort: "createdAt", desc: true};
        const response = await needAuth.post(`/rental?${getParam(pageable)}`, search);
        const items = response?.data?.content ?? [];
        const match = items.find((item) => matchesAssetId(item, assetId));
        if (match?.id) {
            return match.id;
        }
    }

    return null;
};

const getRentalAssetByAssetId = async (assetId) => {
    if (!assetId) {
        return null;
    }

    try {
        const rentalId = await findRentalAssetIdByAssetId(assetId);
        if (!rentalId) {
            return null;
        }

        const detail = await apiRequest(() => needAuth.get(`/rental/${rentalId}`));
        if (!detail || detail.asset?.id !== assetId) {
            return null;
        }

        const code = detail.code;
        return {
            ...detail,
            rentalAssetCode: code ? {...code} : detail.rentalAssetCode,
            rentalAssetCodeId: code?.id ?? detail.rentalAssetCodeId,
        };
    } catch (error) {
        if (error instanceof AxiosError) {
            return null;
        }
        return null;
    }
}

export {
    getRentalAssets, getRentalAsset, getRentalAssetByAssetId, saveRentalAssets, removeRentalAsset, updateRentalAssetCode,
    changeRentalAssetActive, getRentalAssetsForDrawer
}